// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__n+oYF","slider":"Switch_slider__CmgZ0","round":"Switch_round__ajZpd"};